import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { AuthNGuardService } from './authn-guard.service';

@Injectable({
    providedIn: 'root'
})
export class AuthZGuard implements CanActivate {

    constructor(private authService: AuthNGuardService, private router: Router) {}

    async canActivate(route: ActivatedRouteSnapshot): Promise<any> {
        const isActivated = await this.authService.canActivate(route);
        if (isActivated) {
            const pathpermissions = route?.data?.permissions || [];
            if(!pathpermissions?.length) return true;
            for (const permission of pathpermissions)
                if (this.authService?.currentUser?.roles?.includes(permission)) return true;

            return false;
        }
        return false;
    }
}

